import React, { useEffect, useState } from 'react';

import { observer } from 'mobx-react';

import classes from './UserFeesTab.module.scss';
import { PaymentDetailsWidget } from './PaymentDetailsWidget/PaymentDetailsWidget';
import { FeeModuleWidget } from '../../../../containers/FeeModuleWidget/FeeModuleWidget';
import { SelfBillingFeeTermsWidget } from '../../../../containers/SelfBillingFeeTermsWidget/SelfBillingFeeTermsWidget';
import { FreeAccessWidget } from '../../../../containers/FreeAccessWidget/FreeAccessWidget';
import { FeeTermsInfo } from '../../../../interfaces/feeTerms';
import { loggedInUserDataStore } from '../../../../../shared/stores/loggedInUserDataStore';
import { entityGeneralSetupService } from '../../../../services/entityGeneralSetupService';
import { EntityType } from '../../../../../shared/constants/user-info/ENTITY_TYPES';
import { EntityPlanWidget } from './EntityPlanWidget/EntityPlanWidget';

type UserFeesTabProps = {
  entityId: number;
  entityType: EntityType;
};

const UserFeesTab = observer(({ entityId, entityType }: UserFeesTabProps) => {
  const [feeTerms, setFeeTerms] = useState<FeeTermsInfo>();

  const { isSuperAdmin } = loggedInUserDataStore;

  const getFeeTerms = async () => {
    const response = await entityGeneralSetupService.getFeeTerms(entityId);
    setFeeTerms(response);
  };

  useEffect(() => {
    getFeeTerms();
  }, []);

  return (
    <>
      <div className={classes.row} style={{ height: '264px' }}>
        <EntityPlanWidget entityId={entityId} />
        <PaymentDetailsWidget entityId={entityId} />
      </div>

      <div className={classes.row}>
        {isSuperAdmin && <FeeModuleWidget entityId={entityId} entityType={entityType} />}
        <SelfBillingFeeTermsWidget
          entityId={entityId}
          isFeeTermsCreated={!!feeTerms}
          defaultMode="VIEW"
          feeTerms={feeTerms}
        />
      </div>
      <FreeAccessWidget entityId={entityId} />
    </>
  );
});

export { UserFeesTab };
